import { apiClient } from '../../api/client';
import { endpoints } from '../../api/endpoints';
import type { Order } from '../../types';
import type {
  IyzicoCompleteRequest,
  IyzicoCompleteResponse,
  IyzicoInitiateRequest,
  IyzicoInitializeResponse,
} from '../../types/payment';

type BackendCompleteResponse = {
  order: Order;
  paymentReference: string;
};

export async function httpInitializeIyzico(
  payload: IyzicoInitiateRequest,
): Promise<IyzicoInitializeResponse> {
  if (!payload.order?.items?.length) {
    throw new Error('Ödeme başlatılamadı: sipariş bilgileri eksik.');
  }

  return apiClient<IyzicoInitializeResponse>(endpoints.payments.iyzico.initialize, {
    method: 'POST',
    body: {
      amount: payload.amount,
      currency: payload.currency,
      order: payload.order,
    },
  });
}

export async function httpCompleteIyzico(
  payload: IyzicoCompleteRequest,
): Promise<IyzicoCompleteResponse> {
  const response = await apiClient<BackendCompleteResponse>(endpoints.payments.iyzico.complete, {
    method: 'POST',
    body: payload,
  });

  return {
    order: response.order,
    paymentReference: response.paymentReference,
    paymentStatus: 'success',
  };
}
